/* import __COLOCATED_TEMPLATE__ from './decline-on-archive.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import { closeModal } from 'sh-www/utils/modal-controls';

const CLASS_NAME = 'SH-c-decline-on-archive-modal';

class DeclineOnArchiveModal extends Component {
  @service ('commands/application-commands') applicationCommandService;
  @service ('state-managers/application') applicationStateManager;
  @service('error-tracker') errorTracker;

  @tracked declineMessage = '';

  get className() {
    return CLASS_NAME;
  }

  @task
  *archiveAndDecline() {
    const { pendingProjects } = this.args.model;
    const pendingProjectIds = pendingProjects.map((project) => project.id);

    try {
      yield this.applicationCommandService.declineApplications(pendingProjectIds, this.declineMessage);
      closeModal(this);
    } catch(error) {
      this.errorTracker.error(`archiveAndDecline failed to decline projects for ids ${pendingProjectIds}`, this, error);
      const projectToastMessage = pendingProjectIds.length > 1 ? 'these projects' : 'this project';
      this.applicationStateManager.addToast(`Failed to decline ${projectToastMessage}. Please try again.`);
    }
  }

  @action
  handleDeclineProjectInput(value) {
    this.declineMessage = value;
  }

  @action
  handleDismiss() {
    closeModal(this);
  }
}

export default DeclineOnArchiveModal;
